import React from "react";
import {
  withStyles,
  Theme,
  WithStyles,
  createStyles,
} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "../components/Typography";
import {
  ChatAdd,
  RefreshDouble,
  Trash,
  ShieldQuestion,
} from "iconoir-react";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(8),
    },
    title: {
      marginBottom: theme.spacing(5),
    },
    item: {
      display: "flex",
      alignItems: "flex-start",
      marginBottom: theme.spacing(3),
    },
    icon: {
      flexShrink: 0,
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(0.5),
    },
  });

const issues = [
  {
    icon: ShieldQuestion,
    title: "OAuth authorization problems",
    description: "Use the password option to sign in. Magic links may not work if the Slack app is installed.",
  },
  {
    icon: ChatAdd,
    title: "How do I add more statuses?",
    description: "Go to the Status tab and click the + icon in the top-right corner.",
  },
  {
    icon: Trash,
    title: "Removing a connected workspace",
    description: "Open the Dubslack app, select the Accounts tab, and click the trash icon to remove it from your account list to revoke Dubslack's access.",
  },
  {
    icon: RefreshDouble,
    title: "Workspace administrator approval required",
    description: "Some Slack workspaces require approval from a Workspace Owner or Administrator before a new app can be installed. Ask them to approve or install \"Dubstatus\", the name Dubslack's Slack integration appears under in Slack.",
  },
];

function CommonIssues(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <Container className={classes.container}>
      <Typography variant="h4" marked="center" align="center" className={classes.title}>
        Common Issues
      </Typography>
      <Grid container spacing={4}>
        {issues.map((issue, index) => {
          const Icon = issue.icon;
          return (
            <Grid item xs={12} md={6} key={index}>
              <div className={classes.item}>
                <div className={classes.icon}>
                  <Icon color={"#4095D1"} width={"2em"} height={"2em"} />
                </div>
                <div>
                  <Typography variant="h6" gutterBottom>
                    {issue.title}
                  </Typography>
                  <Typography variant="body1">{issue.description}</Typography>
                </div>
              </div>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
}

export default withStyles(styles)(CommonIssues);
